import { supabase } from '@/lib/supabase/client';

export interface Invoice {
  id: string;
  clientId: string;
  processId: string | null;
  invoiceNumber: string;
  amount: number;
  taxAmount: number;
  totalAmount: number;
  status: 'pending' | 'paid' | 'overdue' | 'cancelled';
  issueDate: string;
  dueDate: string;
  paidDate: string | null;
  notes: string | null;
  createdAt: string;
  updatedAt: string;
}

export async function getInvoicesByClientId(clientId: string): Promise<Invoice[]> {
  try {
    const { data, error } = await supabase
      .from('invoices')
      .select('*')
      .eq('client_id', clientId)
      .order('issue_date', { ascending: false });

    if (error) throw error;

    return (data || []).map(row => ({
      id: row.id,
      clientId: row.client_id,
      processId: row.process_id,
      invoiceNumber: row.invoice_number,
      amount: row.amount,
      taxAmount: row.tax_amount,
      totalAmount: row.total_amount,
      status: row.status,
      issueDate: row.issue_date,
      dueDate: row.due_date,
      paidDate: row.paid_date,
      notes: row.notes,
      createdAt: row.created_at,
      updatedAt: row.updated_at
    }));
  } catch (error) {
    console.error('Error fetching invoices:', error);
    return [];
  }
}

export async function getAllInvoices(): Promise<Invoice[]> {
  try {
    const { data, error } = await supabase
      .from('invoices')
      .select('*')
      .order('issue_date', { ascending: false });

    if (error) throw error;

    return (data || []).map(row => ({
      id: row.id,
      clientId: row.client_id,
      processId: row.process_id,
      invoiceNumber: row.invoice_number,
      amount: row.amount,
      taxAmount: row.tax_amount,
      totalAmount: row.total_amount,
      status: row.status,
      issueDate: row.issue_date,
      dueDate: row.due_date,
      paidDate: row.paid_date,
      notes: row.notes,
      createdAt: row.created_at,
      updatedAt: row.updated_at
    }));
  } catch (error) {
    console.error('Error fetching all invoices:', error);
    return [];
  }
}